<div class="file-upload-container">
    <label for="formFile" class="file-upload-label">{{label}}</label>
    <div class="file-upload-area" (click)="triggerFileInput()">
        <div class="camera-box">
            <div class="camera-icon-container">
                <i class="pi pi-camera camera-icon"></i>
                <div class="plus-icon"><i class="pi pi-plus upload-icone"></i></div>
            </div>
        </div>
        <div class="text-box">
            <div class="upload-text">{{innerLabe | translator}}</div>
        </div>
    </div>
    <input 
        #uploadInput 
        class="file-input-hidden" 
        type="file" 
        id="formFile" 
        (input)="handleFileUpload($event)" 
        accept="{{accept}}">
    <p-progressBar 
        [style]="{'width': '100%'}" 
        *ngIf="uploadingFile" 
        [value]="uploadProgress">
    </p-progressBar>
</div>